export function ParseError(message, path, id)
{
    this.message = message;
    this.path = path;
    this.id = id;
}

ParseError.prototype = Error.prototype;
ParseError.prototype.name = 'ParseError';
ParseError.prototype.constructor = ParseError;


// WEBPACK FOOTER //
// ./src/core/objects/errors.js